import { bindable, bindingMode, autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject
export class CreditCardForm {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) creditCardInformation;
	billingNameLabel: string;

	constructor(private i18n:I18N) {
		this.billingNameLabel = this.i18n.i18next.t('cardHolderName','Card Holder Name');
	}
}
